export class Panic extends Error {
  constructor(message: string, context: object) {
    super(message + " " + JSON.stringify(context));
  }
}
